import { MessageSquarePlus } from 'lucide-react';
import { useEffect } from 'react';
import { useStore } from '../store/useStore';

export function FeedbackPage() {
  const openFeedbackModal = useStore((s) => s.openFeedbackModal);

  useEffect(() => {
    openFeedbackModal();
  }, [openFeedbackModal]);

  return (
    <div className="flex flex-col items-center justify-center h-full gap-4 text-center p-8">
      <MessageSquarePlus className="w-10 h-10 text-zinc-600" />
      <h1 className="text-xl font-semibold text-zinc-200">Feedback</h1>
      <p className="text-sm text-zinc-500">Partagez vos retours via la fenêtre de feedback.</p>
    </div>
  );
}
